import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export default function useLocationDelay() {
  const location = useLocation();

  const [delayHasBeenConsumed, setDelayHasBeenConsumed] = useState(
    location.state === undefined ||
    location.state.delay === undefined ||
    location.state.delay === 0
  );

  useEffect(function() {
    if (
      location.state === undefined ||
      location.state.delay === undefined ||
      location.state.delay === 0
    ) {
      return;
    }

    if (delayHasBeenConsumed) return;

    const id = setTimeout(() => (
      setDelayHasBeenConsumed(true)
    ), location.state.delay);

    return function() {
      clearTimeout(id);
    }
  }, [delayHasBeenConsumed, location.state]);

  return delayHasBeenConsumed;
}
